import React, {useContext} from 'react';
import loadable from '@loadable/component';
import PropTypes from "prop-types";
import get from "lodash/get";

import { definedValue } from '../../utils';
import { PortalConfigContext } from '../../config/portal';
import {isServer} from "../../store/utils";

import './styles.css';

const FooterFlexible = (props) => {
  const context = useContext(PortalConfigContext);
  const footer = definedValue(context.footerFlexible, {});
  const layout = definedValue(footer.layout, []);

  const supports = get(context, 'supports');
  const supportsCmp = get(supports, 'cmp', false);

  const renderFooterElement = (element, index) => {
    const Element = loadable(() => import(`../${element.path}`));
    const elementProps = {
      key: `footer-${element.name}`,
      context: {...element.context},
      customContext: {...props.customContext}
    };

    if (index === layout.length - 1) {
      return (
        <div className="footer-disclaimers-container" key={elementProps.key}>
          <Element {...elementProps} />
          {!isServer() && supportsCmp && (
            <div className="footer-cmp">
              <div id="teconsent"></div>
            </div>
          )}
        </div>
      );
    }

    return <Element {...elementProps} />;
  };

  return (
    <footer className="main-footer">
      {layout.map((element, index) => renderFooterElement(element, index))}
    </footer>
  );
};

FooterFlexible.propTypes = {
  customContext: PropTypes.object
};

FooterFlexible.defaultProps = {
  customContext: {
    showFooterSupportLink: true
  }
};

export default FooterFlexible;
